import { DiagnosisListItem } from "@sequel-care/types"
import { IGroupOptionV2, INestedGroupOptionV2, IOptionV2 } from "components/v2/components/common/selects/selectsTypes"

const transformDiagnosis = (diagnosis: DiagnosisListItem[]): IGroupOptionV2[] => {
    const createNestedStructure = (parentDiag: DiagnosisListItem): IGroupOptionV2 => {
        const immediateChildren = diagnosis.filter((diag) => diag.super_diagnoses?.includes(parentDiag.id))

        const processedOptions: Array<IOptionV2 | INestedGroupOptionV2> = immediateChildren.map((child) => {
            if (child.sub_diagnoses && child.sub_diagnoses.length > 0) {
                const subDiagnoses = diagnosis.filter((diag) => child.sub_diagnoses?.includes(diag.id))

                const nestedGroup: INestedGroupOptionV2 = {
                    groupName: child.name,
                    options: subDiagnoses.map(
                        (subDiag): IOptionV2 => ({
                            id: Number(subDiag.id),
                            title: subDiag.name
                        })
                    )
                }
                return nestedGroup
            }

            return {
                id: Number(child.id),
                title: child.name
            }
        })

        return {
            groupName: parentDiag.name,
            options: processedOptions
        }
    }

    const topLevelDiagnoses = diagnosis.filter(
        (diag) =>
            (!diag.super_diagnoses || diag.super_diagnoses.length === 0) &&
            diag.sub_diagnoses &&
            diag.sub_diagnoses.length > 0
    )

    return topLevelDiagnoses.map((topDiag) => createNestedStructure(topDiag))
}

export default transformDiagnosis
